import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Fairfax City Cannabis</p>
        <h1>Your Source for Cannabis News and Information</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis policy, legal status, and cultural insights in Fairfax City. Our mission is to provide comprehensive coverage and educational resources for residents and enthusiasts alike.
        </p>
        <div className="cta-row">
          <a href="/law-updates" target="_self">
            Latest Law Updates
          </a>
          <a href="/education" target="_self" className="secondary">
            Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Cannabis Policy Updates</h2>
          <p>
            Keep up with the evolving landscape of cannabis legislation in Fairfax City. Our coverage includes recent changes, upcoming votes, and community discussions.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Navigate the complexities of cannabis legality in your area. We provide clear information about what is permitted and what to be aware of regarding cannabis use and possession.
          </p>
        </article>
        <article>
          <h2>Educational Insights</h2>
          <p>
            Explore articles and guides that delve into cannabis culture, health benefits, and responsible usage. Empower yourself with knowledge and stay informed.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;